import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _ArrowIosLeft;
import ArrowIosLeft from '@crehana/compass.icons.outline/ArrowIosLeft';
import { toast } from '@crehana/compass.ui/toaster';
import { useSupplanting } from "../../hooks/use-supplanting/use-supplanting";
import { useProfileUITranslations } from "../../i18n";
import { useReturnUserAccountMutationMutation } from "./hooks/graphql/return-user-account.v5.generated";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ExitImpressionation = function ExitImpressionation(_ref) {
  var organizationSlug = _ref.organizationSlug;
  var _useProfileUITranslat = useProfileUITranslations(),
    t = _useProfileUITranslat.t;
  var _useSupplanting = useSupplanting(),
    organizationId = _useSupplanting.organizationId,
    restUsersMapping = _useSupplanting.restUsersMapping,
    mainUserId = _useSupplanting.mainUserId;
  var _useReturnUserAccount = useReturnUserAccountMutationMutation(),
    _useReturnUserAccount2 = _slicedToArray(_useReturnUserAccount, 1),
    switchUserMutation = _useReturnUserAccount2[0];
  var onSwitchUser = function onSwitchUser() {
    if (!organizationId) {
      toast.error('Organization ID is not valid');
      return;
    }
    if (!mainUserId) {
      toast.error('The root user ID is not found');
      return;
    }
    switchUserMutation({
      variables: {
        input: {
          impersonating_user_id: mainUserId,
          impersonated_users: restUsersMapping,
          organization_id: organizationId
        }
      },
      context: {
        clientName: 'v5'
      },
      onCompleted: function onCompleted(r) {
        var typename = r.security.return_switch_user_account.__typename || '';
        if (['LoginMutationPayload', 'SwitchedUserPayload'].includes(typename)) {
          toast.success(t('SWITCHER_EXIT_SUCCESS'));
          window.location.replace("".concat(window.location.origin, "/org/").concat(organizationSlug, "/home/"));
        } else {
          toast.error(t('SWITCHER_EXIT_ERROR'));
        }
      },
      onError: function onError() {
        return toast.error(t('SWITCHER_EXIT_ERROR'));
      }
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    role: "button",
    "aria-hidden": "true",
    onClick: onSwitchUser,
    className: "tw-p-1.2 tw-flex tw-items-center tw-border-b tw-border-solid tw-border-b-neutral-light-400",
    children: [_ArrowIosLeft || (_ArrowIosLeft = /*#__PURE__*/_jsx(ArrowIosLeft, {
      size: 20,
      className: "tw-text-neutral-light-800"
    })), /*#__PURE__*/_jsx("p", {
      className: "tw-font-link1 tw-text-neutral-light-700",
      children: t('SWITCHER_EXIT')
    })]
  });
};